{
  "header": {
    "title": "Alerts",
    "description": "Get notified when your charging stations or sessions need attention."
  },
  "noAccess": {
    "title": "No access",
    "description": "We couldn't load your account. Try again in a moment."
  },
  "table": {
    "title": "Alert rules",
    "count": "{{count}} alerts",
    "count_one": "{{count}} alert",
    "count_other": "{{count}} alerts",
    "searchPlaceholder": "Search alerts",
    "searchAria": "Search alerts by name",
    "columns": {
      "name": "Alert",
      "owner": "Owner",
      "type": "Type",
      "schedule": "Schedule",
      "lastRun": "Last run",
      "status": "Status"
    },
    "empty": {
      "title": "No alerts yet",
      "description": "Create an alert to start watching your stations or sessions."
    },
    "error": {
      "title": "Couldn't load alerts",
      "description": "Something went wrong. Try again in a moment."
    }
  },
  "types": {
    "ChargingStation": "Charging station",
    "Transaction": "Transaction"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "execStatus": {
    "Success": "Issues found",
    "NoData": "All clear",
    "Failed": "Failed"
  },
  "interval": {
    "minutes": "Every {{count}} minutes",
    "minutes_one": "Every minute",
    "minutes_other": "Every {{count}} minutes",
    "hours": "Every {{count}} hours",
    "hours_one": "Every hour",
    "hours_other": "Every {{count}} hours"
  },
  "lastRun": {
    "never": "Never run",
    "found": "{{count}} items",
    "found_one": "{{count}} item",
    "found_other": "{{count}} items"
  },
  "actions": {
    "new": "New alert",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save",
    "enable": "Enable",
    "disable": "Disable",
    "history": "Run history"
  },
  "form": {
    "addTitle": "New alert",
    "editTitle": "Edit alert",
    "description": "Choose what to watch and how often to check.",
    "fields": {
      "name": "Name",
      "recipients": "Recipients",
      "type": "Alert type",
      "interval": "Run every",
      "startFrom": "Start from",
      "active": "Active",
      "staleDuration": "Running longer than (minutes)",
      "maxEnergy": "Energy above (kWh)",
      "lowSoc": "State of charge below (%)",
      "emailTemplate": "Email message"
    },
    "placeholders": {
      "name": "e.g. Faulted stations",
      "recipients": "name@example.com, ops@example.com",
      "type": "Select a type",
      "emailTemplate": "Leave empty for the default message, or write your own using the parameters below."
    },
    "sections": {
      "stationStatuses": "Charging station status",
      "socketStatuses": "Socket status",
      "transactionConditions": "Alert when a session is…",
      "emailMessage": "Email message"
    },
    "hints": {
      "active": "When active, the alert runs on its schedule. Turn it off to pause it without deleting.",
      "recipients": "Comma-separated email addresses to notify when this alert fires.",
      "startFrom": "Leave empty to start immediately.",
      "emailTemplate": "Click a parameter to insert it. Leave the message empty to use the default."
    },
    "errors": {
      "name": "Enter a name.",
      "recipients": "Enter at least one valid email address.",
      "statuses": "Select at least one status.",
      "conditions": "Enable at least one condition and give it a value."
    }
  },
  "stationStatus": {
    "OFFLINE": "Offline"
  },
  "socketStatus": {
    "FAULTED": "Faulted",
    "INOPERATIVE": "Inoperative",
    "OCCUPIED": "Occupied",
    "RESERVED": "Reserved",
    "AVAILABLE": "Available",
    "UNKNOWN": "Unknown"
  },
  "conditions": {
    "stale": "Running too long",
    "energy": "Using too much energy",
    "lowSoc": "Stopped at a low state of charge"
  },
  "deleteDialog": {
    "title": "Delete alert?",
    "description": "Delete \"{{name}}\" and its run history? This can't be undone.",
    "confirm": "Delete"
  },
  "executions": {
    "title": "Run history",
    "empty": {
      "title": "No runs yet",
      "description": "This alert hasn't run yet."
    },
    "columns": {
      "when": "When",
      "status": "Result",
      "items": "Items",
      "summary": "Summary"
    },
    "error": {
      "title": "Couldn't load history",
      "description": "Something went wrong. Try again in a moment."
    }
  },
  "toasts": {
    "saved": "Alert saved.",
    "saveFailed": "Couldn't save the alert.",
    "deleted": "Alert deleted.",
    "deleteFailed": "Couldn't delete the alert.",
    "toggled": "Alert updated.",
    "toggleFailed": "Couldn't update the alert."
  },
  "owner": {
    "tenant": "Tenant",
    "organisation": "Organisation",
    "wholeFleet": "Whole fleet",
    "wholeFleetHint": "All stations"
  }
}
